// extracted by extract-css-chunks-webpack-plugin
module.exports = {"prev":"QGBsI","next":"_3aTl2","playButton":"uU4Wx","playButtonVideoPlacement":"ZaStM","text":"R2g-M","carouselContainerGallery":"Alzay","slideContainer":"_4PjwT"};